import REPORT from "./Report";

export { REPORT };



// WEBPACK FOOTER //
// src/modules/screens/reporting/ContactListCallStatistics/components/index.js